import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { CampaignShimmeredDetailsList } from '@bingads-webui-grid/campaign-details-list';
import { GridContext } from './';

export function ContextualDetailsList(props) {
  const gridContext = useContext(GridContext);

  const {
    dispatch,
    state: {
      items, totalCount, selectedColumns, sortedColumn, pagination, selectionMode, selection, columnProcessors,
    },
  } = gridContext;
  const { pageNumber, pageSize } = pagination;
  const {
    showPagination,
    availablePageSizes,
  } = props;

  if (selection) {
    // eslint-disable-next-line no-underscore-dangle
    selection._onSelectionChanged = () => {
      dispatch({ type: 'SET_SELECTED_ITEMS', payload: selection.getSelection() });
    };
  }

  function pageChange(v) {
    dispatch({ type: 'UPDATE_PAGINATION', payload: { pageNumber: v, pageSize } });
  }

  function pageSizeChange(v) {
    dispatch({ type: 'UPDATE_PAGINATION', payload: { pageNumber: 1, pageSize: v } });
  }

  function handleSort(column) {
    dispatch({ type: 'UPDATE_SORTED_COLUMN', payload: column });
    dispatch({ type: 'UPDATE_PAGINATION', payload: { pageNumber: 1, pageSize } });
  }

  return (
    <CampaignShimmeredDetailsList
      enableShimmer={!items}
      items={items || []}
      columns={selectedColumns}
      onSort={col => handleSort(col)}
      sortedColumn={sortedColumn}
      selectionMode={selectionMode}
      selection={selection}
      didMount={() => dispatch({ type: 'TABLE_DID_MOUNT' })}
      didUpdate={(prev) => {
        dispatch({ type: 'TABLE_DID_UPDATE', payload: prev });
      }}
      pager={
          showPagination
            ? {
                pageNumber: pageNumber || 1,
                pageSize,
                total: totalCount || 0,
                availablePageSizes,
                onPageChange: pageChange,
                onPageSizeChange: pageSizeChange,
              }
            : undefined
        }
      listProps={{ ignoreScrollingState: true }}
      columnProcessors={columnProcessors}
        // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}

ContextualDetailsList.propTypes = {
  showPagination: PropTypes.bool,
  availablePageSizes: PropTypes.arrayOf(PropTypes.number),
};

ContextualDetailsList.defaultProps = {
  showPagination: true,
  availablePageSizes: undefined,
};
